( function( global, $ ) {

    $(document).on('click', '.c-fabric-swatch', function() {
        var fabricSwatch = $(this);
        var fabricSwatchId = fabricSwatch.data('id');

        // Set active swatch for index
        fabricSwatch.siblings('.c-fabric-swatch').removeClass('is-active');
        fabricSwatch.addClass('is-active');

        // Set active swatch for modal
        var $modalSwatch = $('.js-modal-fabric-swatch[data-id="' + fabricSwatchId + '"]');
        $modalSwatch.siblings('.js-modal-fabric-swatch').removeClass('is-active');
        $modalSwatch.addClass('is-active');
        $modalSwatch.click();

        setMainSwatchValues(fabricSwatch);
    });

    function setMainSwatchValues(fabricSwatch) {

        console.dir(fabricSwatch);

        var fabricSwatchTitle = fabricSwatch.data('title');
        var $cardInner = fabricSwatch.parents('.c-card__inner');
        var $card = $cardInner.siblings('.c-card');

        fabricSwatch.siblings('.c-fabric-title').text(fabricSwatchTitle);
        $cardInner.find('.c-fabric-pattern').text(fabricSwatch.data('patterns'));
        $cardInner.find('.c-fabric-manufacturer').text(fabricSwatch.data('manufacturers'));

        if (fabricSwatch.data('image-border')) {
            $card.find('.c-card__cover').removeClass('h-border');
        } else {
            $card.find('.c-card__cover').addClass('h-border');
        }

        $card.find('figure').html('<img src="' + fabricSwatch.attr('src').replace('_thumb', '_sm') + '" alt="' + fabricSwatchTitle + '">');
    }

    // Load all swatches for fabric on modal
    $(document).on('click', '.js-modal-fabric', function() {
        var $fabric = $(this);

        // Prevent appending colors more than once
        if ($fabric.is('[colors-loaded]')) {
            return;
        }

        var fabricId = $fabric.data('id');
        var $modal = $('#modal' + fabricId);
        var $modalTriggers = $('[data-id="' + fabricId + '"]');

        $modal.find('[modal-fabric-content]').addClass('is-loading');

        var modalFabrics = $('[data-modal-fabrics]');
        var data = {
            'fabricId' : fabricId
        };

        data[modalFabrics.data('csrf-name')] = modalFabrics.data('csrf-token');

        $.ajax({
            url: 'actions/website/default/get-fabric-colors',
            dataType: 'JSON',
            type: 'POST',
            data: data,
            success: function(data) {
                if (data.colors) {
                    var $colors = $modal.find('.modal-fabric-colors');

                    $.each(data.colors, function(index, color) {
                        var swatch = '<img src="' + color.image.thumb + '" alt="' + color.title + '" class="js-modal-fabric-swatch' + (color.border ? ' h-border' : '') + '" data-id="' + color.id + '";"/>';
                        $colors.append(swatch);
                    });
                }

                $modalTriggers.attr('colors-loaded', '');
            }, complete: function() {
                $('#modal' + fabricId).find('[modal-fabric-content]').removeClass('is-loading');
            }
        });
    });

    // Load swatch info
    $(document).on('click', '.js-modal-fabric-swatch', function() {
        var $fabric = $(this);
        var fabricId = $fabric.data('id');
        var $modal = $fabric.parents('.modal');

        $($modal).find('[modal-fabric-content]').addClass('is-loading');

        // Set active swatch for modal
        $modal.find('.js-modal-fabric-swatch').removeClass('is-active');
        $fabric.addClass('is-active');

        // Set active swatch for index
        var mainSwatch = $('.c-fabric-swatch[data-id="' + fabricId + '"]');
        if (mainSwatch.length) {
            mainSwatch.siblings('.c-fabric-swatch').removeClass('is-active');
            mainSwatch.addClass(('is-active'));

            setMainSwatchValues(mainSwatch);
        }

        var modalFabrics = $('[data-modal-fabrics]');
        var data = {
            'fabricId' : fabricId
        };

        data[modalFabrics.data('csrf-name')] = modalFabrics.data('csrf-token');

        $.ajax({
            url: 'actions/website/default/get-fabric-data',
            dataType: 'JSON',
            type: 'POST',
            data: data,
            success: function(data) {
                if (data.fabric) {
                    var image = '<div class="fabric-image__figure"><img src="' + data.fabric.image.sm + '" alt="' + data.fabric.title + '"></div>';
                    $modal.find('.c-fabric-image').html(image);
                    $modal.find('.c-fabric-modal__title').text(data.fabric.patterns ? data.fabric.patterns : '-');
                    $modal.find('.manufacturer').find('p').text(data.fabric.manufacturers ? data.fabric.manufacturers : '-');
                    $modal.find('.abrasion').find('p').text(data.fabric.abrasion ? data.fabric.abrasion : '-');
                    $modal.find('.applications').find('p').text(data.fabric.applications ? data.fabric.applications : '-');
                    $modal.find('.content').find('p').text(data.fabric.content ? data.fabric.content : '-');
                    $modal.find('.current-color').find('p').text(data.fabric.color ? data.fabric.color : '-');
                    $modal.find('.finishes-treatments').find('p').text(data.fabric.finishesTreatments ? data.fabric.finishesTreatments : '-');
                    $modal.find('.grade').find('p').text(data.fabric.grade ? data.fabric.grade : '-');
                    $modal.find('[data-clipboard]').attr('data-clipboard', data.fabric.encodedUrl);
                    $modal.find('[data-clipboard-confirm]').attr('data-clipboard-confirm', data.fabric.encodedUrl);

                    var $socialIcons = $modal.find('.social-icons');
                    $socialIcons.find('.email').attr('href', 'mailto:?subject=' + data.fabric.title + '&body=' + data.fabric.encodedUrl);

                    var $imageDownload = $modal.find('.modal-fabric-image-download');
                    if (data.fabric.image.url.length > 0 && $imageDownload.find('a').length) {
                        $imageDownload.find('a').attr('href', data.fabric.image.url);
                        $imageDownload.removeClass('is-hidden');
                    } else {
                        $imageDownload.addClass('is-hidden');
                    }
                }
            }, complete: function () {
                $($modal).find('[modal-fabric-content]').removeClass('is-loading');
            }
        });

    });

}( window.groots, jQuery));
